import Vue from 'vue'
import Vuex from 'vuex'
import Router from 'vue-router'

Vue.use(Vuex)
Vue.use(Router)



import { store } from '../storage/vuex-store.js' 

import { mapGetters } from 'vuex'
import { mapMutations } from 'vuex'
import { mapActions } from 'vuex'











//MISC LIBRARIES

import VueAnalytics from 'vue-analytics'
import axios from 'axios'
import AxiosStorage from 'axios-storage'
import session from 'sessionstorage'
import apiconfig from '../../static/api.config.js'
const uuidv4 = require('uuid/v4')





// // AUTHENTICATION
const login = () => import('@/views/login')
// import login from '@/views/login'

const dfa = () => import('@/views/dfa')
// import dfa from '@/views/dfa'


const logout = () => import('@/views/logout')
// import logout from '@/views/logout'

const register = () => import('@/views/register')
// import register from '@/views/register'




// //VIEWS - AUTH NOT REQ
const home = () => import('@/views/home')
// import home from '@/views/home'





// //VIEWS - AUTH REQ
const dashboard = () => import('@/views/dashboard')
// import dashboard from '@/views/dashboard'

// //VIEWS - ORGANIZATION
const contacts = () => import('@/views/contacts')
// import contacts from '@/views/contacts'

const companies = () => import('@/views/companies')
// import companies from '@/views/companies'


const company = () => import('@/views/company')
// import company from '@/views/company'

const order_history = () => import('@/views/order_history')
// import order_history from '@/views/order_history'

const order_summary = () => import('@/views/order_summary')
// import order_summary from '@/views/order_summary'

const esp_orders = () => import('@/views/esp_orders')
// import esp_orders from '@/views/esp_orders'

const product_designs = () => import('@/views/product_designs')
// import product_designs from '@/views/product_designs'

const old_product_designs = () => import('@/views/old_product_designs')
// import product_designs from '@/views/product_designs'

const esp_shipments = () => import('@/views/esp_shipments')
// import esp_shipments from '@/views/esp_shipments'

const esp_pd_prices = () => import('@/views/esp_pd_prices')
// import esp_pd_prices from '@/views/esp_pd_prices'

const esp_stockline = () => import('@/views/esp_stockline')
// import esp_stockline from '@/views/esp_stockline'




const support = () => import('@/views/support')
// import support from '@/views/support'



// //VIEWS = AUTH REQ & ADMIN REQ
const admin_panel = () => import('@/views/admin_panel')
// import admin_panel from '@/views/admin_panel'

const kdc_settings = () => import('@/views/kdc_settings')
// import admin_settings from '@/views/admin_settings'

const kdc_customization = () => import('@/views/kdc_customization')
// import admin_settings from '@/views/admin_settings'

const kdc_configurator = () => import('@/views/kdc_configurator')
// import kdc_configurator from '@/views/kdc_configurator'

const data_workbench = () => import('@/views/data_workbench')
// import data_workbench from '@/views/data_workbench'

const vue_services = () => import('@/views/vue_services')
// import vue_services from '@/views/vue_services'

const esp_services = () => import('@/views/esp_services')
// import esp_services from '@/views/esp_services'

const users = () => import('@/views/users')
// import users from '@/views/users'

const groups = () => import('@/views/groups')
// import groups from '@/views/groups'

const view_roles = () => import('@/views/view_roles')
// import view_roles from '@/views/view_roles'

const page_access_old = () => import('@/views/page_access_old')
// import page_access from '@/views/page_access'

const page_access = () => import('@/views/page_access')
// import page_access from '@/views/page_access'

const custom_report = () => import('@/views/custom_report')
// import custom_report from '@/views/custom_report'

const plant_admin = () => import('@/views/plant_admin')
// import plant_admin from '@/views/plant_admin'

const shop_settings = () => import('@/views/shop_settings')
// import shop_settings from '@/views/shop_settings'

const manage_account = () => import('@/views/manage_account')
// import manage_account from '@/views/manage_account'


// const kdc_settings = () => import('@/views/kdc_settings')
// import shop_settings from '@/views/shop_settings'


// import accesses from '@/views/accesses'
// import permissions from '@/views/permissions'




// //SHOP
const shop = () => import('@/views/shop')
// import shop from '@/views/shop'

const shopping_cart = () => import('@/components/shopping_cart')
// import shopping_cart from '@/components/shopping_cart'

const public_shop = () => import('@/views/public_shop')
// import shop from '@/views/shop'

const public_shopping_cart = () => import('@/components/public_shopping_cart')
// import shopping_cart from '@/components/shopping_cart'




const pagination = () => import('@/components/pagination')
// import pagination from '@/components/pagination'

const pagination_control = () => import('@/components/pagination_control')
// import pagination_control from '@/components/pagination_control'



// //RSP
const paper_admin = () => import('@/views/paper_admin')

const paper_requirements = () => import('@/views/paper_requirements')
// import paper_requirements from '@/views/paper_requirements'

const paper_projections = () => import('@/views/paper_projections')
// import paper_projections from '@/views/paper_projections'

const vendor_allocation = () => import('@/views/vendor_allocation')
// import vendor_allocation from '@/views/vendor_allocation'

const roll_source_orders = () => import('@/views/roll_source_orders')
// import roll_source_orders from '@/views/roll_source_orders'

const maintain_order_datatable = () => import('@/datatables/maintain_order_datatable')
// import maintain_order from '@/views/maintain_order'

const edit_pending_roll_source_order = () => import('@/datatables/edit_pending_roll_source_order')
// import edit_pending_roll_source_order from '@/views/edit_pending_roll_source_order'

const macop_frame = () => import('@/views/macop_frame')
// import macop_frame from '@/views/macop_frame'

const roll_editor = () => import('@/views/roll_editor')
// import roll_editor from '@/views/roll_editor'






// //EXECUTIVE
const executive_month_to_date = () => import('@/views/executive_month_to_date')
// import executive_month_to_date from '@/views/executive_month_to_date'
const executive_month_to_date_sales = () => import('@/views/executive_month_to_date_sales')
// import executive_month_to_date_sales from '@/views/executive_month_to_date_sales'
const executive_month_to_date_sales_old = () => import('@/views/executive_month_to_date_sales_old')
// import executive_month_to_date_sales from '@/views/executive_month_to_date_sales'

// //SALES
const sales_chart = () => import('@/views/sales_chart')
// import sales_chart from '@/views/sales_chart'

const sales_month_to_date = () => import('@/views/sales_month_to_date')
// import sales_month_to_date from '@/views/sales_month_to_date'
const sales_month_to_date_sales = () => import('@/views/sales_month_to_date_sales')
// import sales_month_to_date_sales from '@/views/sales_month_to_date_sales'
const sales_month_to_date_sales_old = () => import('@/views/sales_month_to_date_sales_old')
// import sales_month_to_date_sales from '@/views/sales_month_to_date_sales'

const backlog = () => import('@/views/backlog')
// import backlog from '@/views/backlog'
const overdue_orders = () => import('@/views/overdue_orders')
// import backlog from '@/views/overdue_orders'


// LABS
const kdc_datatable = () => import('@/views/kdc_datatable')
// import kdc_datatable from '@/views/kdc_datatable'

const companies_kdatatable = () => import('@/datatables/companies_kdatatable.vue')
// import companies_kdatatable from '@/views/companies_kdatatable'


const watchlists = () => import('@/views/watchlists')
// import watchlists from '@/views/watchlists'





var vthis = this;



let router = new Router({
	mode: 'history',
	store,
	routes: [

	// Public Views 👇
	{
		path: '/login',
		name: 'login',
		component: login,
		meta:{
			title: 'Login',
			view_face: 'public',
			requiredAuth: false
		}
	},
	{
		path: '/public_shop',
		name: 'public_shop',
		component: public_shop,
		meta:{
			title: 'Public Shop',
			view_face: 'public'
		}
	},
	{
		path: '/public_shopping_cart',
		name: 'public_shopping_cart',
		component: public_shopping_cart,
		meta:{
			title: 'Public Shopping Cart',
			view_face: 'public'
		}
	},
	//Public Views ☝

	{
		path: '/dashboard',
		name: 'dashboard',
		component: dashboard,
		meta: {
			title: 'Dashboard',
			requiredAuth: 'USER'
		}
	},
	{
		path: '/',
		redirect: 'login',
		pathMatch: 'full'
	},
	{
		path: '/register',
		name: 'register',
		component: register,
		meta: {
			requiredAuth: 'none'
		}
	},   
	{
		path: '/logout',
		name: 'logout',
		component: logout,
		meta: {
			title: 'Logout',
			requiredAuth: 'none'
		}
	},
	{
		path: '/manage_account',
		name: 'manage_account',
		component: manage_account,
		meta: {
			title: 'Manage Account',
			requiredAuth: 'USER'
		}
	}, 
	{
		path: '/order_history',
		name: 'order_history',
		component: order_history,
		meta: {
			title: 'Order History',
			requiredAuth: 'USER'
		}
	},
	{
		path: '/order_summary',
		name: 'order_summary',
		component: order_summary,
		meta: {
			title: 'Order Summary',
			requiredAuth: 'USER'
		}
	},
	{
		path: '/admin_panel',
		name: 'admin_panel',
		component: admin_panel,
		meta: {
			title: 'Admin Panel',
			requiredAuth: 'ADMIN'
		}
	},
	{
		path: '/kdc_settings',
		name: 'kdc_settings',
		component: kdc_settings,
		meta: {
			title: 'KDC Settings',
			requiredAuth: 'ADMIN'
		}
	},
	{
		path: '/kdc_customization',
		name: 'kdc_customization',
		component: kdc_customization,
		meta: {
			title: 'KDC Customization',
			requiredAuth: 'ADMIN'
		}
	},
	{
		path: '/kdc_configurator',
		name: 'kdc_configurator',
		component: kdc_configurator,
		meta: {
			title: 'KDC configurator',
			requiredAuth: 'ADMIN'
		}
	},
	{
		path: '/data_workbench',
		name: 'data_workbench',
		component: data_workbench,
		meta: {
			title: 'Data Workbench',
			requiredAuth: 'ADMIN'
		}
	},
	{
		path: '/kdc_datatable',
		name: 'kdc_datatable',
		component: kdc_datatable,
		meta: {
			title: 'KDC DataTable',
			requiredAuth: 'ADMIN'
		}
	},
	{
		path: '/watchlists',
		name: 'watchlists',
		component: watchlists,
		meta: {
			title: 'KDC Watch Lists',
			requiredAuth: 'SALES'
		}
	},
	
	{
		path: '/plant_admin',
		name: 'plant_admin',
		component: plant_admin,
		meta: {
			title: 'Plant Admin',
			requiredAuth: 'ADMIN'
		}
	},
	{
		path: '/vue_services',
		name: 'vue_services',
		component: vue_services,
		meta: {
			title: 'Vue Services',
			requiredAuth: 'ADMIN'
		}
	},
	{
		path: '/esp_services',
		name: 'esp_services',
		component: esp_services,
		meta: {
			title: 'ESP Services',
			requiredAuth: 'ADMIN'
		}
	},
	{
		path: '/users',
		name: 'users',
		component: users,
		meta:{
			title: 'Users',
			requiredAuth: 'ADMIN'
		}
	},
	{
		path: '/groups',
		name: 'groups',
		component: groups,
		meta:{
			title: 'Groups',
			requiredAuth: 'ADMIN'
		}  
	},
	{
		path: '/esp_orders',
		name: 'esp_orders',
		component: esp_orders,
		meta: {
			title: 'ESP Orders',
			requiredAuth: 'USER'
		}
	},
	{
		path: '/esp_shipments',
		name: 'esp_shipments',
		component: esp_shipments,
		meta: {
			title: 'ESP Shipments',
			requiredAuth: 'USER'
		}
	},
	{
		path: '/esp_stockline',
		name: 'esp_stockline',
		component: esp_stockline,
		meta: {
			title: 'ESP Stockline',
			requiredAuth: 'USER'
		}
	},
	{
		path: '/contacts',
		name: 'contacts',
		component: contacts,
		meta: {
			title: 'Contacts',
			requiredAuth: 'USER'
		}
	},
	{
		path: '/companies',
		name: 'companies',
		component: companies,
		meta: {
			title: 'Companies',
			requiredAuth: 'USER'
		}
	},
	{
		path: '/company',
		name: 'company',
		component: company,
		meta: {
			title: 'Company',
			requiredAuth: 'USER'
		}
	},
	{
		path: '/product_designs',
		name: 'product_designs',
		component: product_designs,
		meta: {
			title: 'Product Designs',
			requiredAuth: 'USER'
		}
	},
	{
		path: '/old_product_designs',
		name: 'old_product_designs',
		component: old_product_designs,
		meta: {
			title: 'OLD Product Designs',
			requiredAuth: 'USER'
		}
	},
	{
		path: '/shop_settings',
		name: 'shop_settings',
		component: shop_settings,
		meta: {
			title: 'Shop Settings',
			requiredAuth: 'CUSTOMER SERVICE'
		}
	},
	{
		path: '/shop',
		name: 'shop',
		component: shop,
		meta:{
			title: 'Shop',
			requiredAuth: 'USER',
			view_face: 'public'
		}
	},
	{
		path: '/shopping_cart',
		name: 'shopping_cart',
		component: shopping_cart,
		meta:{
			title: 'Shopping Cart',
			requiredAuth: 'USER',
			view_face: 'public'
		}
	},
	
	{
		path: '/support',
		name: 'support',
		component: support,
		meta:{
			title: 'Support',
			requiredAuth: 'USER'
		}
	},
	{
		path: '/paper_projections',
		name: 'paper_projections',
		component: paper_projections,
		meta:{
			title: 'Paper Projections',
			requiredAuth: 'USER'
		}
	},
	{
		path: '/paper_admin',
		name: 'paper_admin',
		component: paper_admin,
		meta: {
			title: "Paper Admin",
			requiredAuth: "ADMIN"
		}
	},
	{
		path: '/paper_requirements',
		name: 'paper_requirements',
		component: paper_requirements,
		meta: {
			title: 'Paper Requirements',
			requiredAuth: 'USER'
		}
	},
	{
		path: '/vendor_allocation',
		name: 'vendor_allocation',
		component: vendor_allocation,
		meta:{
			title: 'Vendor Allocation',
			requiredAuth: 'ADMIN'
		}
	},
	{
		path: '/roll_source_orders',
		name: 'roll_source_orders',
		component: roll_source_orders,
		meta:{
			title: 'Roll Source Orders',
			requiredAuth: 'ADMIN'
		}

	},
	{
		path: '/maintain_order_datatable/:batch',
		name: 'maintain_order_datatable',
		component: maintain_order_datatable,
		props: true,
		meta:{
			title: 'Maintain Roll Source Order',
			requiredAuth: 'ADMIN'
		}
	},
	{
		path: '/edit_pending_roll_source_order/:batches',
		name: 'edit_pending_roll_source_order',
		component: edit_pending_roll_source_order,
		props: true,
		meta: {
			title: 'Edit Pending Roll Source Order',
			requiredAuth: 'ADMIN'
		}
	},
	{
		path: '/view_roles',
		name: 'view_roles',
		component: view_roles,
		meta:{
			title: 'View Roles',
			requiredAuth: 'ADMIN'
		}
	},
	{
		path: '/page_access_old',
		name: 'page_access_old',
		component: page_access_old,
		meta:{
			title: 'Page Access OLD',
			requiredAuth: 'ADMIN'
		}
	},
	{
		path: '/page_access',
		name: 'page_access',
		component: page_access,
		meta:{
			title: 'Page Access',
			requiredAuth: 'ADMIN'
		}
	},
	{
		path: '/sales_chart',
		name: 'sales_chart',
		component: sales_chart,
		meta:{
			title: "Sales Chart",
			requiredAuth: 'SALES'
		}
	},
	{
		path: '/executive_month_to_date',
		name: 'executive_month_to_date',
		component: executive_month_to_date,
		meta: {
			title: "Executive Month to Date Sales",
			requiredAuth: "EXECUTIVE"
		}
	},
	{
		path: '/executive_month_to_date_sales',
		name: 'executive_month_to_date_sales',
		component: executive_month_to_date_sales,
		meta: {
			title: "Sales Month to Date Sales",
			requiredAuth: "EXECUTIVE"
		}
	},
	{
		path: '/executive_month_to_date_sales_old',
		name: 'executive_month_to_date_sales_old',
		component: executive_month_to_date_sales_old,
		meta: {
			title: "Sales Month to Date Sales OLD",
			requiredAuth: "EXECUTIVE"
		}
	},
	{
		path: '/sales_month_to_date_sales',
		name: 'sales_month_to_date_sales',
		component: sales_month_to_date_sales,
		meta: {
			title: "Month to Date",
			requiredAuth: "SALES"
		}
	},
	{
		path: '/sales_month_to_date_sales_old',
		name: 'sales_month_to_date_sales_old',
		component: sales_month_to_date_sales_old,
		meta: {
			title: "Month to Date OLD",
			requiredAuth: "SALES"
		}
	},
	{
		path: '/backlog',
		name: 'backlog',
		component: backlog,
		meta: {
			title: "Backlog",
			requiredAuth: "SALES"
		}
	},
	{
		path: '/overdue_orders',
		name: 'orderdue_orders',
		component: overdue_orders,
		meta: {
			title: "Overdue Orders",
			requiredAuth: "SALES"
		}
	},
	{
		path: '/macop',
		name: 'macop_frame',
		component: macop_frame,
		meta:{
			title: "Macop",
			requiredAuth: "ADMIN"
		}
	},
	{
		path: '/roll_editor',
		name: 'Roll Editor',
		component: roll_editor,
		meta:{
			title: "Roll Editor",
			requiredAuth: "ADMIN"
		}
	},
	{
		path: '/custom_report',
		name: 'custom_report',
		component: custom_report,
		meta: {
			title: 'Custom Report',
			requiredAuth: 'USER'
		}
	}]
	
})


router.beforeEach((to, from, next) => {
	

	if(session.getItem('user')){
		console.log('user exists')

		

		if(to.path === '/login'){
			store.commit('set_display_navigation_components', false)
			store.commit('set_display_navbar_component', false)
			store.commit('set_display_sidenav_component', false)

		}else if(to.path === '/logout'){
			store.commit('set_display_navigation_components', false)
			store.commit('set_display_navbar_component', false)
			store.commit('set_display_sidenav_component', false)
		}else{
			store.commit('set_display_navigation_components', true)
			store.commit('set_display_navbar_component', true)
			store.commit('set_display_sidenav_component', true)
		}
		
	

	}else{

	
		if(to.meta.view_face == 'public'){
			//if public pages
			if(to.path === '/login'){
				//if login, display no navigator elements

			}else{
				//all other public pages, display navigator elements
				store.commit('set_display_navigation_components', true)
				store.commit('set_display_navbar_component', true)
				store.commit('set_display_sidenav_component', true)

				if(session.getItem('user')){
					console.log(session.getItem('user'))
					//if user session exists, do nothing

				}else{
					console.log('creating a unique user')
					//else make a unique user and session
					var user = 	{
						id: uuidv4(),
						username: 'Guest',
						group: 'GUEST'
					}

					session.setItem('user', JSON.stringify(user))
					store.dispatch('set_user_session')				
				}
			}
		}else{
			//else private pages
			console.log('private pages')


			if(to.path === '/logout'){
				//if logging out
				store.commit('set_display_navigation_components', false)
				store.commit('set_display_navbar_component', false)
				store.commit('set_display_sidenav_component', false)

			}else{
				//all other private pages
				console.log('not logout')
				console.log(store.getters.user_session)

				if(store.getters.user_session){
					if(store.getters.user_session.group !== 'GUEST'){
						console.log('not guest')
						store.commit('set_display_navigation_components', true)
						store.commit('set_display_navbar_component', true)
						store.commit('set_display_sidenav_component', true)
					}else{
		
						router.push('/login')
		
					}
				}else{

					store.commit('set_requested_route', to.path)

					router.push('/login')

				}


			}
		}

	}

	// // session.setItem('user', user)
	// store.dispatch('set_user_session')
	
	next()
	
	
})

router.afterEach((to, from) => {
    Vue.nextTick(() => {
        document.title = 'KDC:' + to.meta.title || 'KDC';
    });
});





Vue.use(VueAnalytics, {
id: 'UA-145330039-1',
router,
pageviewTemplate (route) {
	return {
	  page: route.path,
	  title: document.title,
	  location: window.location.href
	}
  }
})


export default router


// WEBPACK FOOTER //
// ./src/router/index.js